export default {
  // 分区雨量列表
  GET_AREA_RAINFALL_RAIN: ' GET_AREA_RAINFALL_RAIN',
  // 分区雨量导出
  EXPORT_AREA_RAINFALL_RAIN: 'EXPORT_AREA_RAINFALL_RAIN',
  // 水库动态蓄水列表
  GET_DYNAMIC_RESERVOIR_STORAGE: 'GET_DYNAMIC_RESERVOIR_STORAGE',
  // 水库动态蓄水导出
  EXPORT_DYNAMIC_RESERVOIR_STORAGE: 'EXPORT_DYNAMIC_RESERVOIR_STORAGE',
  // 到站率统计
  STATION_ARRIVE_RATE: 'STATION_ARRIVE_RATE',
  // 水雨情简报
  WATER_RAIN_BRIEFING: 'WATER_RAIN_BRIEFING',
  // 水雨情日报
  WATER_RAIN_DAILY: 'WATER_RAIN_DAILY',
  // 水情快报
  WATER_NEWS: 'WATER_NEWS',
  /*
   雨水情告知单
   */
  GET_RAIN_WATER_NOTICE_TEMPLATE: 'GET_RAIN_WATER_NOTICE_TEMPLATE', // 获取雨水情告知单模板
  SAVE_RAIN_WATER_NOTICE: 'SAVE_RAIN_WATER_NOTICE', // 保存
  GET_LIST_RAIN_WATER_NOTICE: 'GET_LIST_RAIN_WATER_NOTICE', // 获取列表
  DELETE_RAIN_WATER_NOTICE: 'DELETE_RAIN_WATER_NOTICE', // 删除
  GET_LIST_WARN_RECORD_TIME: 'GET_LIST_WARN_RECORD_TIME', // 获取已经预警时间
  /*
   异常数据报表
   */
  GET_ABNORMAL_VAVAL: 'GET_ABNORMAL_VAVAL', // 获取设定的异常值
  SAVE_GET_ABNORMAL_DATA: 'SAVE_GET_ABNORMAL_DATA', // 保存设定的异常值
  SAVE_ABNORMAL_DATA: 'SAVE_ABNORMAL_DATA', // 保存异常数据
  GET_ABNORMAL_DATA: 'GET_ABNORMAL_DATA', // 获取列表
  EXPORT_PROBLEM_STATION: 'EXPORT_PROBLEM_STATION' // 导出缺报数据
}
